import { diffDates } from '@fullcalendar/core';
import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    reportes: [],
    soporte: {}
};
const mutations = {
    updateField,
    updateSoportes: (state, payload) =>{
        state.reportes = payload;
    },
    updateSoporte: (state, payload) =>{
        state.soporte = payload;
    }
};

const getters = {
    getField
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
